export const TESTOSTERONE_STEP_STATUS = {
  IN_PROGRESS: "in_progress",
  INCOMPLETE: "incomplete",
  COMPLETED: "completed",
} as const;

export const TESTOSTERONE_STEP_TYPES = {
  FORM: "form",
  INTAKE_FORM: "intake_form",
  BIOMARKERS_TEST: "biomarkers_test",
  PROVIDER_CONSULTATION: "provider_consultation",
} as const;

export const TESTOSTERONE_STEP_ACTION_TYPES = {
  COMPLETE_FORM: "complete_form",
  COMPLETE_INTAKE_FORM: "complete_intake_form",
  GET_REQUISITION_FORM: "get_requisition_form",
  SCHEDULE_LAB: "schedule_lab",
  SCHEDULE_CONSULTATION: "schedule_consultation",
} as const;
